export const GET_LMDEPARTMENTS_API_REQUEST = "GET_LMDEPARTMENTS_API_REQUEST";
export const GET_LMDEPARTMENTS_API_SUCCESS = "GET_LMDEPARTMENTS_API_SUCCESS";
export const GET_LMDEPARTMENTS_API_ERROR = "GET_LMDEPARTMENTS_API_ERROR";

export const POST_LISTINGS_API_REQUEST = "POST_LISTINGS_API_REQUEST";
export const POST_LISTINGS_API_SUCCESS = "POST_LISTINGS_API_SUCCESS";
export const POST_LISTINGS_API_ERROR = "POST_LISTINGS_API_ERROR";

export const EDIT_LIVE_DEPARTMENTS = "EDIT_LIVE_DEPARTMENTS"

export const GET_ENGINELOCATIONS_API_REQUEST = "GET_ENGINELOCATIONS_API_REQUEST";
export const GET_ENGINELOCATIONS_API_SUCCESS = "GET_ENGINELOCATIONS_API_SUCCESS";
export const GET_ENGINELOCATIONS_API_ERROR = "GET_ENGINELOCATIONS_API_ERROR";

export const POST_ENGINELOCATIONS_API_REQUEST = "POST_ENGINELOCATIONS_API_REQUEST";
export const POST_ENGINELOCATIONS_API_SUCCESS = "POST_ENGINELOCATIONS_API_SUCCESS";
export const POST_ENGINELOCATIONS_API_ERROR = "POST_ENGINELOCATIONS_API_ERROR";

